1<template>
  <div class="staffSummaryPk">
    <div class="filters">
      <el-form :inline="true">
        <!-- 时间 -->
        <el-form-item>
          <el-date-picker v-model="datevalues" type="daterange" :range-separator="$t('lang.lab_to')"
            :start-placeholder="$t('lang.lab_startDate')" :end-placeholder="$t('lang.lab_endDate')"
            value-format="timestamp"></el-date-picker>
        </el-form-item>
        <el-button type="primary" @click="print" style="float:right;">打印pdf</el-button>
        <!-- 提交button -->
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <div id="print">
      <el-row class="rowTop" :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-title bg-purple leftTop">物业人员信息</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="closeIcon" v-if="staffData1.staffName" @click="delStaffPk(1,staffData1.staffName)">×</div>
          <div class="grid-title bg-purple">
            <el-image class="staffImg" :src="staffData1.avatarUri"></el-image>
            <el-select class="w280" v-model="staffVal1" filterable placeholder="请选择" @change="selectChanged1">
              <el-option v-for="item in staffList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="closeIcon" v-if="staffData2.staffName" @click="delStaffPk(2,staffData2.staffName)">×</div>
          <div class="grid-title bg-purple">
            <el-image class="staffImg" :src="staffData2.avatarUri"></el-image>
            <el-select class="w280" v-model="staffVal2" filterable placeholder="请选择" @change="selectChanged2">
              <el-option v-for="item in staffList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="closeIcon" v-if="staffData3.staffName" @click="delStaffPk(3,staffData3.staffName)">×</div>
          <div class="grid-title bg-purple">
            <el-image class="staffImg" :src="staffData3.avatarUri"></el-image>
            <el-select class="w280" v-model="staffVal3" filterable placeholder="请选择" @change="selectChanged3">
              <el-option v-for="item in staffList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">姓名</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{staffData1.staffName}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{staffData2.staffName}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049">{{staffData3.staffName}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">性别</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3" v-if="staffData1.gender==1">女</div>
          <div class="grid-content bg-purple c-00b1c3" v-else-if="staffData1.gender==2">男</div>
          <div class="grid-content bg-purple c-00b1c3" v-else></div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599" v-if="staffData2.gender==1">女</div>
          <div class="grid-content bg-purple c-ed8599" v-else-if="staffData2.gender==2">男</div>
          <div class="grid-content bg-purple c-ed8599" v-else></div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049" v-if="staffData3.gender==1">女</div>
          <div class="grid-content bg-purple c-b4d049" v-else-if="staffData3.gender==2">男</div>
          <div class="grid-content bg-purple c-b4d049" v-else></div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">工龄</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{staffData1.workYears}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{staffData2.workYears}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049">{{staffData3.workYears}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">管辖户数</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{staffData1.staffRecordCount}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{staffData2.staffRecordCount}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049">{{staffData3.staffRecordCount}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">多种经营金额</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{staffData1.sklTotalPrice}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{staffData2.sklTotalPrice}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049">{{staffData3.sklTotalPrice}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">服务项目数量</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{staffData1.staffGardens?staffData1.staffGardens.length:''}}
          </div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{staffData2.staffGardens?staffData2.staffGardens.length:''}}
          </div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049">{{staffData3.staffGardens?staffData3.staffGardens.length:''}}
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="0" class="row-equal-height">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel col-content">服务项目名称</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3 col-content">{{staffData1.staffGardenNames}}
          </div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599 col-content">{{staffData2.staffGardenNames}}
          </div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049 col-content">{{staffData3.staffGardenNames}}
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">业主工单</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{staffData1.yezhuMaintain}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{staffData2.yezhuMaintain}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049">{{staffData3.yezhuMaintain}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">物业工单</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{staffData1.wuyeMaintain}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{staffData2.wuyeMaintain}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049">{{staffData3.wuyeMaintain}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">巡检工单</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{staffData1.jobMaintain}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{staffData2.jobMaintain}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049">{{staffData3.jobMaintain}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">报单数量</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{staffData1.baodanMaintain}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{staffData2.baodanMaintain}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049">{{staffData3.baodanMaintain}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">接单数量</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{staffData1.jiedanMaintain}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{staffData2.jiedanMaintain}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049">{{staffData3.jiedanMaintain}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">居家服务工单</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{staffData1.jujiafuwuMaintain}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{staffData2.jujiafuwuMaintain}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049">{{staffData3.jujiafuwuMaintain}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">居家服务收入</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{staffData1.maintainPriceStaff}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{staffData2.maintainPriceStaff}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049">{{staffData3.maintainPriceStaff}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">历史工单数</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{staffData1.hMaintain}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{staffData2.hMaintain}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049">{{staffData3.hMaintain}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">日均报单量</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <!-- <div class="grid-content bg-purple">{{staffData1.oneDayMaintainCount>0?staffData1.oneDayMaintainCount:0}}</div> -->
          <div class="grid-content bg-purple c-00b1c3" v-if="staffData1.oneDayMaintainCount">
            {{staffData1.oneDayMaintainCount>0?staffData1.oneDayMaintainCount:0}}</div>
          <div class="grid-content bg-purple c-00b1c3" v-else-if="staffData1.staffName">0</div>
          <div class="grid-content bg-purple c-00b1c3" v-else></div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599" v-if="staffData2.oneDayMaintainCount">
            {{staffData2.oneDayMaintainCount>0?staffData2.oneDayMaintainCount:0}}</div>
          <div class="grid-content bg-purple c-ed8599" v-else-if="staffData2.staffName">0</div>
          <div class="grid-content bg-purple c-ed8599" v-else></div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049" v-if="staffData3.oneDayMaintainCount">
            {{staffData3.oneDayMaintainCount>0?staffData3.oneDayMaintainCount:0}}</div>
          <div class="grid-content bg-purple c-b4d049" v-else-if="staffData3.staffName">0</div>
          <div class="grid-content bg-purple c-b4d049" v-else></div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">子工单均量</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{staffData1.parentMaintain}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{staffData2.parentMaintain}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049">{{staffData3.parentMaintain}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">GBA接单量</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{staffData1.gbaJiedan}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{staffData2.gbaJiedan}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049">{{staffData3.gbaJiedan}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">业主投诉量</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{staffData1.complainMaintain}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{staffData2.complainMaintain}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049">{{staffData3.complainMaintain}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">业主标签户均值</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{staffData1.userDrawCount}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{staffData2.userDrawCount}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049">{{staffData3.userDrawCount}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">信用值</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{staffData1.serviceCommission}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{staffData2.serviceCommission}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049">{{staffData3.serviceCommission}}</div>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">APP绑定率</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3" v-if="staffData1.appBind">
            {{((staffData1.appBind.T_A4_6_*100).toFixed(2))+'%'}}</div>
          <div class="grid-content bg-purple c-00b1c3" v-else-if="staffData1.staffName">0.00%</div>
          <div class="grid-content bg-purple c-00b1c3" v-else></div>
          <!-- <div class="grid-content bg-purple c-00b1c3">{{staffData1.appBind?((staffData1.appBind.T_A4_6_*100).toFixed(2))+'%':''}}</div> -->
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599" v-if="staffData2.appBind">
            {{((staffData2.appBind.T_A4_6_*100).toFixed(2))+'%'}}</div>
          <div class="grid-content bg-purple c-ed8599" v-else-if="staffData2.staffName">0.00%</div>
          <div class="grid-content bg-purple c-ed8599" v-else></div>
          <!-- <div class="grid-content bg-purple c-ed8599">{{staffData2.appBind?((staffData2.appBind.T_A4_6_*100).toFixed(2))+'%':''}}</div> -->
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049" v-if="staffData3.appBind">
            {{((staffData3.appBind.T_A4_6_*100).toFixed(2))+'%'}}</div>
          <div class="grid-content bg-purple c-b4d049" v-else-if="staffData3.staffName">0.00%</div>
          <div class="grid-content bg-purple c-b4d049" v-else></div>
          <!-- <div class="grid-content bg-purple c-b4d049">{{staffData3.appBind?((staffData3.appBind.T_A4_6_*100).toFixed(2))+'%':''}}</div> -->
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">APP打开次数</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{staffData1.staffAppCount}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{staffData2.staffAppCount}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049">{{staffData3.staffAppCount}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">蓝牙门禁使用次数</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{staffData1.doorDeviceRecordCount}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{staffData2.doorDeviceRecordCount}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049">{{staffData3.doorDeviceRecordCount}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">蓝牙梯控使用次数</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{staffData1.liftRecordCount}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{staffData2.liftRecordCount}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049">{{staffData3.liftRecordCount}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">接单及时率</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{staffData1.maintainOverTimeNumByStaff}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{staffData2.maintainOverTimeNumByStaff}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049">{{staffData3.maintainOverTimeNumByStaff}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">工单24小时反馈率</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{staffData1.maintainInTimeFinishNumByStaff}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{staffData2.maintainInTimeFinishNumByStaff}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049">{{staffData3.maintainInTimeFinishNumByStaff}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">工单好评率</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{staffData1.maintainEvaluateNumByStaff}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{staffData2.maintainEvaluateNumByStaff}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049">{{staffData3.maintainEvaluateNumByStaff}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">管辖区域工单24小时反馈率</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{staffData1.maintainInTimeFinishUserByStaff}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{staffData2.maintainInTimeFinishUserByStaff}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049">{{staffData3.maintainInTimeFinishUserByStaff}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">管辖区域工单好评率</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{staffData1.maintainEvaluateUserByStaff}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{staffData2.maintainEvaluateUserByStaff}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049">{{staffData3.maintainEvaluateUserByStaff}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">物业费收缴率</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3" v-if="staffData1.feeReceive">
            {{((staffData1.feeReceive.paid_amount/staffData1.feeReceive.receive_amount)*100).toFixed(2)}}%</div>
          <div class="grid-content bg-purple c-00b1c3" v-else-if="staffData1.staffName">0.00%</div>
          <div class="grid-content bg-purple c-00b1c3" v-else></div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599" v-if="staffData2.feeReceive">
            {{((staffData2.feeReceive.paid_amount/staffData2.feeReceive.receive_amount)*100).toFixed(2)}}%</div>
          <div class="grid-content bg-purple c-ed8599" v-else-if="staffData2.staffName">0.00%</div>
          <div class="grid-content bg-purple c-ed8599" v-else></div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-b4d049" v-if="staffData3.feeReceive">
            {{((staffData3.feeReceive.paid_amount/staffData3.feeReceive.receive_amount)*100).toFixed(2)}}%</div>
          <div class="grid-content bg-purple c-b4d049" v-else-if="staffData3.staffName">0.00%</div>
          <div class="grid-content bg-purple c-b4d049" v-else></div>
        </el-col>
      </el-row>
    </div>
    <div class="contentBox">
      <el-card class="contentCard">
        <div class="container1">
          <div id="echart5"></div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
  /**
   *@ClassName:staffSummaryPk
   *@Description:物业人员数据pk
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2022-11-9
   */
  // import { mapGetters } from 'vuex'
  // import store from '@/store/store'
  import printHtml from '../../../config/printStaff.js'
  export default {
    name: '/manage/main.staffSummaryPk',
    data() {
      return {
        staffId: '',
        gardenId: this.$store.getters.gardenId, // 园区id
        startTs: '',
        endTs: '',
        datevalues: '',
        staffList: [],
        staffData1: {
          avatarUri: 'https://oss.kmyhwy.cn/2025/03/20/d1b5b530-5ee2-49f8-9c85-db27d7c70544.png'
        },
        staffData2: {
          avatarUri: 'https://oss.kmyhwy.cn/2025/03/20/d1b5b530-5ee2-49f8-9c85-db27d7c70544.png'
        },
        staffData3: {
          avatarUri: 'https://oss.kmyhwy.cn/2025/03/20/d1b5b530-5ee2-49f8-9c85-db27d7c70544.png'
        },
        staffVal1: '',
        staffVal2: '',
        staffVal3: '',
        pkArr: [],
        nameArr: [],
      }
    },
    created() {
      this.staffId = this.$store.getters.staffId
      this.staffId == 100006 ? this.staffVal1 = '' : this.staffVal1 = this.$store.getters.staffId
      // this.staffId = 494
      // this.staffVal1 = 494
      this.getYearNow()
      this.getDateNow()
      this.getStaffList()
      if (this.staffId != 100006) {
        this.getStaffData('1', this.staffId)
        this.getDoorData('1', this.staffId)
      }
    },
    methods: {
      print() {
        // window.print()
        setTimeout(() => {
          // 取自己页面需要打印内容的标签
          let printDocument = document.getElementById('print')
          // 取出需要打印的内容
          let printData = printDocument.innerHTML
          // 调用打印方法
          printHtml(printData)
        }, 300)
      },
      // 获取今年1月1日时间
      getYearNow() {
        let y = new Date().getFullYear()
        let time = Date.parse(`${y}-1-1`)
        this.startTs = time
        console.log('今年1月1日时间戳===' + time)
      },
      // 获取当前时间
      getDateNow() {
        var date = new Date()
        var time = date.getTime()
        this.endTs = time
        console.log('当前时间戳===' + time)
      },
      // 获取人员列表数据
      getStaffList() {
        let loading = this.$loading()
        this.$get(
          `/staffAll?staffId=${this.staffId}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res.data)
              this.staffList = res.data
              this.staffListCopy = res.data
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取基本信息数据
      getStaffData(index, id) {
        let loading = this.$loading()
        this.$get(
          `/selectStaffData?startTs=${this.startTs}&endTs=${this.endTs}&staffId=` + id
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              var pkName = ''
              if (index == 1 && this.staffData1.staffName) {
                pkName = this.staffData1.staffName
              }
              if (index == 2 && this.staffData2.staffName) {
                pkName = this.staffData2.staffName
              }
              if (index == 3 && this.staffData3.staffName) {
                pkName = this.staffData3.staffName
              }
              var staffData
              if (index == 1) {
                staffData = this.staffData1
              } else if (index == 2) {
                staffData = this.staffData2
              } else if (index == 3) {
                staffData = this.staffData3
              }
              this.$set(staffData, 'staffName', res.staffName)
              if (res.avatarUri) {
                this.$set(staffData, 'avatarUri', res.avatarUri)
              } else {
                if (res.gender == 1) {
                  this.$set(staffData, 'avatarUri',
                    'https://oss.kmyhwy.cn/2025/03/20/b8c987f8-8ad6-45da-9c7c-9000c58bdc33.png')
                } else {
                  this.$set(staffData, 'avatarUri',
                    'https://oss.kmyhwy.cn/2025/03/20/47ea8a47-0f16-4ed3-9784-ce762ee082e1.png')
                }
              }
              let staffGardenNames
              if (res.staffGardens && res.staffGardens.length > 0) {
                staffGardenNames = res.staffGardens.map(item => item.Name).join('，')
              } else {
                staffGardenNames = ''
              }

              this.$set(staffData, 'workYears', res.workYears)
              this.$set(staffData, 'gender', res.gender)
              this.$set(staffData, 'staffRecordCount', res.staffRecordCount)
              this.$set(staffData, 'sklTotalPrice', res.sklTotalPrice)
              this.$set(staffData, 'maintainTypes', res.maintainTypes)
              this.$set(staffData, 'staffGardens', res.staffGardens)
              this.$set(staffData, 'staffGardenNames', staffGardenNames)
              this.$set(staffData, 'yezhuMaintain', res.yezhuMaintain)
              this.$set(staffData, 'wuyeMaintain', res.wuyeMaintain)
              this.$set(staffData, 'jobMaintain', res.jobMaintain)
              this.$set(staffData, 'baodanMaintain', res.baodanMaintain)
              this.$set(staffData, 'jiedanMaintain', res.jiedanMaintain)
              this.$set(staffData, 'jujiafuwuMaintain', res.jujiafuwuMaintain)
              this.$set(staffData, 'hMaintain', res.hMaintain)
              this.$set(staffData, 'staffAppCount', res.staffAppCount)
              this.$set(staffData, 'maintainOverTimeByStaff', res.maintainOverTimeByStaff)
              this.$set(staffData, 'maintainInTimeFinishByStaff', res.maintainInTimeFinishByStaff)
              this.$set(staffData, 'maintainEvaluateByStaff', res.maintainEvaluateByStaff)
              this.$set(staffData, 'feeReceive', res.feeReceive)
              this.$set(staffData, 'staffGardenGrid', res.staffGardenGrid)
              this.$set(staffData, 'parentMaintain', res.parentMaintain)
              this.$set(staffData, 'complainMaintain', res.complainMaintain)
              this.$set(staffData, 'userDrawCount', res.userDrawCount)
              this.$set(staffData, 'appBind', res.appBind)
              this.$set(staffData, 'oneDayMaintainCount', res.oneDayMaintainCount ? res.oneDayMaintainCount
                .oneDayMaintainCount : 0)
              this.$set(staffData, 'maintainPriceStaff', res.maintainPriceStaff)
              this.$set(staffData, 'serviceCommission', res.serviceCommission)
              this.$set(staffData, 'gbaJiedan', res.gbaJiedan)
              if (res.maintainOverTimeByStaff.length == 0) {
                this.$set(staffData, 'maintainOverTimeNumByStaff', '0.00%')
              } else {
                let sum = 0
                let num = 0
                let scale = 0
                res.maintainOverTimeByStaff.map(function (item) {
                  sum += item.value
                  if (item.name == '未超时') {
                    num = item.value
                  }
                  scale = ((num / sum) * 100).toFixed(2)
                })
                this.$set(staffData, 'maintainOverTimeNumByStaff', scale + '%')
              }
              if (res.maintainInTimeFinishByStaff.length == 0) {
                this.$set(staffData, 'maintainInTimeFinishNumByStaff', '0.00%')
              } else {
                let sum = 0
                let num = 0
                let scale = 0
                res.maintainInTimeFinishByStaff.map(function (item) {
                  sum += item.value
                  if (item.name == '24小时内完成') {
                    num = item.value
                  }
                  scale = ((num / sum) * 100).toFixed(2)
                })
                this.$set(staffData, 'maintainInTimeFinishNumByStaff', scale + '%')
              }
              if (res.maintainEvaluateByStaff.length == 0) {
                this.$set(staffData, 'maintainEvaluateNumByStaff', '0.00%')
              } else {
                let sum = 0
                let num = 0
                let scale = 0
                res.maintainEvaluateByStaff.map(function (item) {
                  sum += item.value
                  if (item.name == '好评') {
                    num = item.value
                  }
                  scale = ((num / sum) * 100).toFixed(2)
                })
                this.$set(staffData, 'maintainEvaluateNumByStaff', scale + '%')
              }
              if (res.maintainEvaluateUserByStaff.length == 0) {
                this.$set(staffData, 'maintainEvaluateUserByStaff', '0.00%')
              } else {
                let sum = 0
                let num = 0
                let scale = 0
                res.maintainEvaluateUserByStaff.map(function (item) {
                  sum += item.value
                  if (item.name == '好评') {
                    num = item.value
                  }
                  scale = ((num / sum) * 100).toFixed(2)
                })
                this.$set(staffData, 'maintainEvaluateUserByStaff', scale + '%')
              }
              if (res.maintainInTimeFinishUserByStaff.length == 0) {
                this.$set(staffData, 'maintainInTimeFinishUserByStaff', '0.00%')
              } else {
                let sum = 0
                let num = 0
                let scale = 0
                res.maintainInTimeFinishUserByStaff.map(function (item) {
                  sum += item.value
                  if (item.name == '24小时内完成') {
                    num = item.value
                  }
                  scale = ((num / sum) * 100).toFixed(2)
                })
                this.$set(staffData, 'maintainInTimeFinishUserByStaff', scale + '%')
              }
              this.pkArr = this.pkArr.filter(item => item.name !== pkName)
              this.nameArr = this.nameArr.filter(item => item !== pkName)
              let pkArr = this.pkArr
              let ldObj = {
                value: [res.yezhuMaintain, res.wuyeMaintain, res.jobMaintain, res.baodanMaintain, res
                  .jiedanMaintain, res.hMaintain
                ],
                name: res.staffName
              }
              pkArr.push(ldObj)
              this.pkArr = pkArr
              let nameArr = this.nameArr
              nameArr.push(ldObj.name)
              this.nameArr = nameArr
              this.getLoadEcharts5(pkArr)
              console.log(this.pkArr)
              console.log(this.nameArr)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取门禁电梯数据
      getDoorData(index, id) {
        let loading = this.$loading()
        var staffData
        if (index == 1) {
          staffData = this.staffData1
        } else if (index == 2) {
          staffData = this.staffData2
        } else if (index == 3) {
          staffData = this.staffData3
        }
        this.$get(
          `/selectStaffDataRecord?startTs=${this.startTs}&endTs=${this.endTs}&staffId=` + id
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.$set(staffData, 'doorDeviceRecordCount', res.doorDeviceRecordCount)
              this.$set(staffData, 'liftRecordCount', res.liftRecordCount)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取雷达图
      getLoadEcharts5(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart5')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart5 = this.$echarts.init(
            document.getElementById('echart5')
          )
          var option5 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              // data: ['Allocated Budget', 'Actual Spending', '张三'],
              data: this.nameArr,
              bottom: '-0',
              left: '0'
            },
            label: {
              // show: true // 显示数值
            },
            radar: {
              indicator: [{
                  name: '业主工单',
                },
                {
                  name: '物业工单',
                },
                {
                  name: '巡检工单',
                },
                {
                  name: '报单数量',
                },
                {
                  name: '接单数量',
                },
                {
                  name: '历史工单',
                }
              ],
              axisName: {
                color: '#6a89cc'
              },
            },
            series: [{
              name: 'Budget vs spending',
              type: 'radar',
              data: data
            }]
          }
          myChart5.setOption(option5)
        }
      },
      // 选择pk人员1
      selectChanged1(value) {
        this.staffList = this.staffListCopy
        this.staffList = this.staffList.filter(item => item.value !== value && item.value !== this.staffVal2 && item
          .value !== this.staffVal3)
        this.getStaffData('1', value)
        this.getDoorData('1', value)
      },
      // 选择pk人员2
      selectChanged2(value) {
        this.staffList = this.staffListCopy
        this.staffList = this.staffList.filter(item => item.value !== value && item.value !== this.staffVal1 && item
          .value !== this.staffVal3)
        this.getStaffData('2', value)
        this.getDoorData('2', value)
      },
      // 选择pk人员3
      selectChanged3(value) {
        this.staffList = this.staffListCopy
        this.staffList = this.staffList.filter(item => item.value !== value && item.value !== this.staffVal1 && item
          .value !== this.staffVal2)
        this.getStaffData('3', value)
        this.getDoorData('3', value)
      },
      // 移除pk人员
      delStaffPk(i, name) {
        this.pkArr = this.pkArr.filter(item => item.name != name)
        this.nameArr = this.nameArr.filter(item => item != name)
        this.getLoadEcharts5(this.pkArr)
        // console.log(this.pkArr)
        // console.log(this.nameArr)
        if (i == 1) {
          this.staffVal1 = ''
          this.staffData1 = {}
          this.staffList = this.staffListCopy
          this.staffList = this.staffList.filter(item => item.value !== this.staffVal2 && item
            .value !== this.staffVal3)
          this.staffData1.avatarUri = 'https://oss.kmyhwy.cn/2025/03/20/d1b5b530-5ee2-49f8-9c85-db27d7c70544.png'
        } else if (i == 2) {
          this.staffVal2 = ''
          this.staffData2 = {}
          this.staffList = this.staffListCopy
          this.staffList = this.staffList.filter(item => item.value !== this.staffVal1 && item
            .value !== this.staffVal3)
          this.staffData2.avatarUri = 'https://oss.kmyhwy.cn/2025/03/20/d1b5b530-5ee2-49f8-9c85-db27d7c70544.png'
        } else if (i == 3) {
          this.staffVal3 = ''
          this.staffData3 = {}
          this.staffList = this.staffListCopy
          this.staffList = this.staffList.filter(item => item.value !== this.staffVal1 && item
            .value !== this.staffVal2)
          this.staffData3.avatarUri = 'https://oss.kmyhwy.cn/2025/03/20/d1b5b530-5ee2-49f8-9c85-db27d7c70544.png'
        }
      },
      // 根据时间段查询pk人员数据
      commit() {
        console.log(this.datevalues)
        this.pkArr = []
        this.nameArr = []
        if (this.datevalues) {
          this.startTs = this.datevalues[0]
          this.endTs = this.datevalues[1]
        } else {
          this.getYearNow()
          this.getDateNow()
        }
        if (this.staffVal1) {
          this.getStaffData(1, this.staffVal1)
          this.getDoorData(1, this.staffVal1)
        }
        if (this.staffVal2) {
          this.getStaffData(2, this.staffVal2)
          this.getDoorData(2, this.staffVal2)
        }
        if (this.staffVal3) {
          this.getStaffData(3, this.staffVal3)
          this.getDoorData(3, this.staffVal3)
        }
      }
    }
  }
</script>

<style lang="scss">
  .staffSummaryPk {
    .el-row {
      background: #fff;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .el-col {
      border-bottom: 1px solid #e8e8e8;
      border-right: 1px solid #e8e8e8;
      text-align: center;
    }

    .row-equal-height{
      display: flex;
    }

    .col-content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: stretch;
      padding: 10px;
    }

    .w-22 {
      width: 22%;
    }

    .w-26 {
      width: 26%;
    }

    .bg-purple {
      background: #fff;
      font-weight: bold;
    }

    .c-00b1c3 {
      color: #00b1c3;
    }

    .c-ed8599 {
      color: #ed8599;
    }

    .c-b4d049 {
      color: #b4d049;
    }

    .grid-title {
      // min-height: 36px;
      padding: 10px 0;
      line-height: 2.2;
      font-size: 24px;
    }

    .grid-content {
      min-height: 36px;
      line-height: 2.2;
    }

    .row-bg {
      padding: 10px 0;
      background-color: #fff;
    }

    .staffImg {
      display: block;
      width: 100px;
      height: 100px;
      margin: 10px auto 10px;
      border-radius: 50%;
    }

    .leftLabel {
      color: #386ed3;
      text-align: right;
      padding-right: 20px;
      font-size: 15px;
    }

    .rowTop {
      height: 200px;

      .el-col {
        height: 100%;
        background-color: #fff;
        position: relative;
      }

      .closeIcon {
        font-size: 40px;
        color: #999;
        position: absolute;
        right: 10px;
      }

      .leftTop {
        color: #386ed3;
        // line-height: 200px;
        margin-top: 50px;
        text-align: right;
        padding-right: 20px;
      }

      .w280 {
        width: 70%;
      }
    }

    .contentBox {
      display: flex;
      margin: 20px 0;

      .contentCard {
        flex: 1;
        margin-right: 20px;
      }

      .contentCard:last-child {
        margin-right: 0;
      }

      .container {
        width: 100%;
        height: 280px;
        margin-left: 30px;
      }

      .container1 {
        width: 100%;
        height: 380px;
        margin-left: 30px;
      }

      .gardenAge {
        margin-left: 24px;
        font-size: 18px;
        font-weight: bold;
        color: #999;

        span {
          font-size: 30px;
          color: #F97F51;
        }
      }
    }

    #echart5 {
      width: 90%;
      height: 100%;
    }
  }
</style>